import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import api from "@webparts/api";

import WebpartTemplate from "@webparts/components/webparts/base/WebpartTemplate.vue";
import WebpartBase from "@webparts/components/webparts/base/WebpartBase";
import Dropdown from '@webparts/components/common/Dropdown.vue';
import NoData from "@webparts/components/common/NoData.vue";
import { LoadingBar } from "@appbase/components/loading";

import {decimalAdjust, IEDate, uGetDateFormat, comma, getLangProperty} from "@appbase/util";

@Component({
    name: 'budget-component',
    components: {
        WebpartTemplate, Dropdown, NoData, LoadingBar
    },
})
export default class BudgetComponent extends Mixins(WebpartBase) {

    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    deptInfoList: Array<budget.BudgetDeptInfo> = [
        {
            deptShortName: "CEO",
            deptCode: "10_164",
            name: "CEO",
            key: "10_164",
            selected: true
        },
        {
            deptShortName: "COO",
            deptCode: "10_275",
            name: "COO",
            key: "10_275",
            selected: false
        },
        {
            deptShortName: "CAG",
            deptCode: "10_120",
            name: "CAG",
            key: "10_120",
            selected: false
        }
    ];

    budgetExpenseData: Array<budget.BudgetExpenseItem> = [
        {
            itemNameResourceId: "예산관리_항목_여비교통비",
            monthlyBudget: 461568,
            monthlyExpense: 0,
            monthlyBalance: 461568,
            performanceRate: 0,
            budgetHalfSum: 8252847,
            expenseHalfSum: 0,
            balanceHalfSum: 8252847,
            execRateHalfSum: 0
        },
        {
            itemNameResourceId: "예산관리_항목_접대비",
            monthlyBudget: 1241,
            monthlyExpense: 0,
            monthlyBalance: 1241,
            performanceRate: 0,
            budgetHalfSum: 382463,
            expenseHalfSum: 0,
            balanceHalfSum: 382463,
            execRateHalfSum: 0
        },
        {
            itemNameResourceId: "예산관리_항목_복리후생비_회식비",
            monthlyBudget: 6679,
            monthlyExpense: 0,
            monthlyBalance: 6679,
            performanceRate: 0,
            budgetHalfSum: 3590213,
            expenseHalfSum: 0,
            balanceHalfSum: 3590213,
            execRateHalfSum: 0
        }
    ];

    selectedMonth: string = uGetDateFormat('yyyy-MM');
    selectedDept: budget.BudgetDeptInfo = {} as budget.BudgetDeptInfo;
    isTotal: boolean = false;
    selectedName: string = '';

    comma: (value: string | number) => string = comma;

    //#region computed

    get totalMonthlyExpense(){
        let total = 0;
        this.budgetExpenseData.map(data => data.monthlyExpense).forEach(expense => total += expense);
        return this.convertUnit(total);
    }

    get totalMonthlyBudget(){
        let total = 0;
        this.budgetExpenseData.map(data => data.monthlyBudget).forEach(budget => total += budget);
        return this.convertUnit(total);
    }

    get totalMonthlyBalance(){
        let total = 0;
        this.budgetExpenseData.map(data => data.monthlyBalance).forEach(balance => total += balance);
        return this.convertUnit(total);
    }

    get monthlyProgress(){
        // let percentage = (this.totalMonthlyExpense / this.totalMonthlyBudget) * 100;
        // Prevent division by zero
        const totalBudget = this.totalMonthlyBudget || 1;
        let percentage = decimalAdjust('round', (this.totalMonthlyExpense / totalBudget) * 100, -2);
        return percentage + '%';
    }

    get monthlyBalanceProgress(){
        // let percentage = (this.totalMonthlyBalance / this.totalMonthlyBudget) * 100;
        // Prevent division by zero
        const totalBudget = this.totalMonthlyBudget || 1;
        let percentage = decimalAdjust('round', (this.totalMonthlyBalance / totalBudget) * 100, -2);
        return percentage + '%';
    }

    get totalBudgetHalfSum(){
        let total = 0;
        this.budgetExpenseData.map(data => data.budgetHalfSum).forEach(budget => total += budget);
        return this.convertUnit(total);
    }

    get totalExpenseHalfSum(){
        let total = 0;
        this.budgetExpenseData.map(data => data.expenseHalfSum).forEach(budget => total += budget);
        return this.convertUnit(total);
    }

    get totalBalanceHalfSum(){
        let total = 0;
        this.budgetExpenseData.map(data => data.balanceHalfSum).forEach(balance => total += balance);
        return this.convertUnit(total);
    }

    get halfSumProgress(){
        // let percentage = (this.totalExpenseHalfSum / this.totalBudgetHalfSum) * 100;
        // Prevent division by zero
        const totalBudget = this.totalBudgetHalfSum || 1;
        let percentage = decimalAdjust('round',(this.totalExpenseHalfSum / totalBudget) * 100, -2);
        return percentage + '%';
    }

    get halfBalanceProgress(){
        // let percentage = (this.totalBalanceHalfSum / this.totalBudgetHalfSum) * 100;
        // Prevent division by zero
        const totalBudget = this.totalBudgetHalfSum || 1;
        let percentage = decimalAdjust('round', (this.totalBalanceHalfSum / totalBudget) * 100, -2);
        return percentage + '%';
    }

    //#endregion


    load() {
        this.loadDeptList().then(async () => {
            await this.loadBudgetData();
        })
    }

    async reload(){
        await this.loadBudgetData();
    }

    async loadDeptList(){
        const _this = this;
        this.loading = true;
        let halfYear = this.getHalfYear();

        // 부서목록 조회
        return api.budget.getBudgetDeptList(this.selectedMonth).then(infos => {
            _this.deptInfoList = infos.map((info, idx) => {
                return {
                    ...info,
                    name: info.deptShortName,
                    key: info.deptCode,
                    selected: idx === 0,
                } as budget.BudgetDeptInfo;
            });
            _this.selectedDept = _this.deptInfoList.filter(x => x.selected)[0] ?? {};
            _this.selectedName = _this.selectedDept.deptShortName ?? "";
            this.loading = false;
        }).catch(e => {
            console.error(e);
            this.loading = false;
        })
    }

    async loadBudgetData(){
        const _this = this;
        this.loading = true;

        // 예산-실적 데이터 조회
        return api.budget.getBudgetExpenseData(this.selectedMonth, this.selectedDept.deptCode, this.isTotal).then(data => {
            _this.budgetExpenseData = data;
            this.loading = false;
        }).catch(e => {
            console.error(e);
            this.loading = false;
        })
    }

    getHalfYear(){
        let month = uGetDateFormat('mm', IEDate(this.selectedMonth));
        return (Number(month) >= 3 && Number(month) <= 8) ? 'H1' : 'H2';
    }

    onChangeDept(dept: budget.BudgetDeptInfo) {
        console.debug('onChangeDept', dept);
        this.deptInfoList = this.deptInfoList.map(d => {
            return {
                ...d,
                selected: d.deptCode === dept.deptCode && d.isTotal === dept.isTotal
            }
        });
        
        this.isTotal = dept.isTotal || false;   
        // Reload data when department changes
        if (!this.preview) {
            this.reload();
        }
    }

    /**
     * Convert unit from 원 to 만원
     * @param amount
     */
    convertUnit(amount: number) {
        return Math.floor(amount/10000);
    }


    @Watch('selectedMonth')
    onSelectedMonthChange() {
        if (!this.preview) {
            this.reload();
        }
    }

    @Watch('selectedDept.deptShortName')
    onSelectedNameChange(newVal : string) {
        if(newVal !== null) {
            this.selectedDept = this.deptInfoList.find(dept => dept.deptShortName === newVal) || {} as budget.BudgetDeptInfo;
            this.onChangeDept(this.selectedDept);
        }
    }

    created() {
        if (!this.preview) {
            this.deptInfoList = [];
            this.budgetExpenseData = [];
            this.load();
        }
    }
}